import { useState, useEffect } from "react";
import api from "../utils/api";
import socket from "../socket";
import { toast } from "react-toastify";

export const useIncomingRequests = (restaurantId) => {
  const [incomingRequests, setIncomingRequests] = useState([]);
  const [incomingLoading, setIncomingLoading] = useState(false);
  const [waiters, setWaiters] = useState([]);

  const fetchIncomingRequests = async () => {
    try {
      setIncomingLoading(true);
      const res = await api.get("/table/received-requests", {
        params: { restaurantId },
      });
      setIncomingRequests(res.data);
    } catch {
      toast.error("Failed to load incoming requests");
    } finally {
      setIncomingLoading(false);
    }
  };

  const fetchWaiters = async () => {
    try {
      const res = await api.get("/allocation/loadwaiters");
      setWaiters(res.data);
    } catch {
      toast.error("Failed to load waiters");
    }
  };

  useEffect(() => {
    if (!restaurantId) return;

    const handleQrRequestCreated = () => {
      fetchIncomingRequests();
    };

    socket.on("qr-request-created", handleQrRequestCreated);
    fetchIncomingRequests();
    fetchWaiters();

    return () => {
      socket.off("qr-request-created", handleQrRequestCreated);
    };
  }, [restaurantId]);

  const handleAcceptQrRequest = async (allocationId, waiterId) => {
    try {
      await api.post(`/table/request/${allocationId}/accept`, {
        restaurantId,
        waiterId,
      });
      toast.success("Request accepted & waiter assigned");
      return true;
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to accept");
      return false;
    }
  };

  const handleRejectQrRequest = async (allocationId) => {
    try {
      await api.post(`/table/request/${allocationId}/reject`, {
        restaurantId,
      });
      toast.success("Request rejected");
      fetchIncomingRequests();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to reject request");
    }
  };

  return {
    incomingRequests,
    incomingLoading,
    waiters,
    fetchIncomingRequests,
    handleAcceptQrRequest,
    handleRejectQrRequest,
  };
};
